import { nanoid } from "@reduxjs/toolkit";
// 递归查找节点
export const findNode = (treeData, targetKey) => {
  for (let i = 0; i < treeData.length; i++) {
    const node = treeData[i];
    if (node.key === targetKey) {
      return node;
    }
    if (node.children && node.children.length > 0) {
      const found = findNode(node.children, targetKey);
      if (found) {
        return found;
      }
    }
  }
  return null;
};
export const removeNodeFromTree = (tree, targetKey)=> {
  return tree.filter(node => {
      if (node.key === targetKey) {
          return false;
      }
      if (node.children && node.children.length > 0) {
          node.children = removeNodeFromTree(node.children, targetKey);
      }
      return true;
  });
}
export default function buildDirectoryTree(files) {
  const root = {
    name: "",
    type: "folder",
    children: [],
  };
  files.forEach((file) => {
    const pathParts =file.fileRelativePath? file.fileRelativePath
      .split("/")
      .filter((p) => p !== ""):[]; // 分割路径并过滤空值
    let currentNode = root;
    if (pathParts.length > 0) {
      // 处理文件夹路径（排除最后一个元素）
      for (let i = 0; i < pathParts.length - 1; i++) {
        const part = pathParts[i];
        let child = currentNode.children?.find(
          (n) => n.name === part && n.type === "folder"
        );

        if (!child) {
          child = {
            name: part,
            type: "folder",
            key: nanoid(),
            children: [],
          };
          currentNode.children = currentNode.children || [];
          currentNode.children.push(child);
        }
        currentNode = child;
      }

      // 添加文件节点
      const fileName = pathParts[pathParts.length - 1];
      currentNode.children?.push({
        name: fileName,
        type: "file",
        key: file.fileUuid,
        suffix:file.fileFormat||'-',
        size:file.fileSize,
        path:file.filePath,
        isLeaf: true,
      });
    } else {
      // 根目录下的文件
      root.children?.push({
        name: file.fileName,
        type: "file",
        key: file.fileUuid,
        suffix:file.fileFormat||'-',
        size:file.fileSize,
        path:file.filePath,
        isLeaf: true,
      });
    }
  });
  return root.children || [];
}


/**
 * 递归查找目标节点的路径（包含自身）
 * @param {Array} treeData 树数据
 * @param {string} targetKey 目标key
 * @param {Array} path 当前路径
 * @returns {Array} 节点路径数组
 */
const findNodePath = (treeData, targetKey, path = []) => {
    for (const node of treeData) {
      const currentPath = [...path, node]; // 存储完整节点对象
      
      // 找到目标节点时返回路径
      if (node.key === targetKey) return currentPath;
      
      // 递归搜索子节点
      if (node.children) {
        const foundPath = findNodePath(node.children, targetKey, currentPath);
        if (foundPath) return foundPath;
      }
    }
    return null;
  };
  
  /**
   * 获取目标节点的所有父级信息（排除第一级）
   * @param {Array} treeData 树数据 
   * @param {string} targetKey 目标key
   * @returns {Array} 父级节点信息数组 [{key, title}]
   */
  export const getParentInfo = (treeData, targetKey) => {
    const path = findNodePath(treeData, targetKey);
    // 排除根节点和目标节点自身
    if (!path || path.length <= 1) return [];

    return path.map(({ key, name,children }) => ({
      key,
      title: name, // 处理 JSX 格式的 title
      children:children || null
    }));
  };